<template>
  <div
    class="color-chip"
    :class="{focused: focused}"
    :style="{'background': colorHex}"
    >
  </div>
</template>

<script>

export default {
  props: {
    color: {
      type: Object,
    },
    focused: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorHex() {
      return this.color ? `#${this.color.color_hex}` : `#ffffffff`
    }
  }
}
</script>

<style lang="scss" scoped>
.color-chip {
  min-width: 20px;
  max-width: 20px;
  height: 20px;
  border-radius: 10px;
}
.focused {
  border: solid 2px #2D9CDB;
}
</style>
